/**
 * Location Page Locators
 */
export const playwright_location_page_add_new_button =
    "location.page.add.new.button";
export const playwright_location_page_location_row =
    "location.page.location.row";

/**
 * Location Drawer Locators
 */
export const playwright_location_drawer_name_input =
    "location.drawer.name.input";
export const playwright_location_drawer_address_1_input =
    "location.drawer.address.1.input";
export const playwright_location_drawer_address_2_input =
    "location.drawer.address.2.input";
export const playwright_location_drawer_city_input =
    "location.drawer.city.input";
export const playwright_location_drawer_state_input =
    "location.drawer.state.input";
export const playwright_location_drawer_state_option =
    "location.drawer.state.option";
export const playwright_location_drawer_postal_code_input =
    "location.drawer.postal.code.input";
export const playwright_location_drawer_latitude_input =
    "location.drawer.latitude.input";
export const playwright_location_drawer_longitude_input =
    "location.drawer.longitude.input";
export const playwright_location_drawer_is_primary_checkbox =
    "location.drawer.is.primary.checkbox";
export const playwright_location_drawer_create_update_button =
    "location.drawer.create.update.button";

/**
 * Location Card Locators
 */
export const playwright_location_card_location_name =
    "location.card.location.name";
export const playwright_location_card_address_1 = "location.card.address.1";
export const playwright_location_card_address_2 = "location.card.address.2";
export const playwright_location_card_city_state = "location.card.city.state";
export const playwright_location_card_postal_code = "location.card.postal.code";
